module.exports = __webpack_public_path__ + "img/2X.3aede937.jpg";